import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export const coreSlice = createSlice({
  name: "stages",
  initialState: () => {
    const initialStageId = uuidv4();
    return {
      goals: [
        {
          id: uuidv4(),
          stages: [initialStageId],
        },
      ],
      stageList: [
        {
          id: initialStageId,
          userActions: [
            {
              parentId: initialStageId,
              actionId: uuidv4(),
              text: "",
            },
          ],
        },
      ],
    };
  },
  reducers: {
    addStage: (state, action) => {
      const newStageId = uuidv4();
      const { goalId, appendAfterIndex } = action.payload;
      const newStage = {
        id: newStageId,
        userActions: [
          {
            parentId: newStageId,
            actionId: uuidv4(),
            text: "",
          },
        ],
      };
      state.stageList.push(newStage);
      const targetGoalId = state.goals.findIndex(
        (d) => d.id === goalId
      );

      if (appendAfterIndex === -1) {
        state.goals[targetGoalId].stages.push(newStageId);
      } else {
        state.goals[targetGoalId].stages.splice(appendAfterIndex + 1, 0, newStageId);
      }
    },
    addUserActionToStage: (state, action) => {
      const { stageId, appendAfterIndex } = action.payload;
      const indexOfStage = state.stageList.findIndex(
        (d) => d.id === stageId
      );
      const newUserAction = {
        parentId: stageId,
        actionId: uuidv4(),
        text: "",
      };

      if (appendAfterIndex === -1) {
        state.stageList[indexOfStage].userActions.push(newUserAction);
      } else {
        state.stageList[indexOfStage].userActions.splice(appendAfterIndex + 1, 0, newUserAction);
      }
    },
    reorderUserActionsWithinStages: (state, action) => {
      const indexOfStage = state.stageList.findIndex(
        (d) => d.id === action.payload.stageId
      );
      state.stageList[indexOfStage] = action.payload.updatedStage;
    },
    reorderUserActionsBetweenStages: (state, action) => {
      const indexOfSourceStage = state.stageList.findIndex(
        (d) => d.id === action.payload.sourceStageId
      );
      const indexOfTargetStage = state.stageList.findIndex(
        (d) => d.id === action.payload.targetStageId
      );
      state.stageList[indexOfSourceStage] = action.payload.updatedSourceStage;
      state.stageList[indexOfTargetStage] = action.payload.targetStage;
    },
    reorderStagesWithinGoals: (state, action) => {
      const indexOfGoal = state.goals.findIndex(
        (d) => d.id === action.payload.goalId
      );
      state.goals[indexOfGoal] = action.payload.updatedGoal;
    },
    reorderStagesBetweenGoals: (state, action) => {
      const { sourceGoalId, targetGoalId, sourceGoal, targetGoal } =
        action.payload;
      const indexOfSourceGoal = state.goals.findIndex(
        (d) => d.id === sourceGoalId
      );
      const indexOfTargetGoal = state.goals.findIndex(
        (d) => d.id === targetGoalId
      );
      state.goals[indexOfSourceGoal] = sourceGoal;
      state.goals[indexOfTargetGoal] = targetGoal;
    },
    addGoal: (state, action) => {
      const { appendAfterIndex } = action.payload;
      const newGoalId = uuidv4();
      const newGoal = {
        id: newGoalId,
        stages: [],
      };
      if (appendAfterIndex === -1) {
        state.goals.push(newGoal);
      } else {
        state.goals.splice(appendAfterIndex + 1, 0, newGoal)
      }
    },
  },
});

export const {
  addStage,
  addUserActionToStage,
  reorderUserActionsWithinStages,
  reorderUserActionsBetweenStages,
  reorderStagesWithinGoals,
  reorderStagesBetweenGoals,
  addGoal,
} = coreSlice.actions;

export const selectStages = (state) => state.root.stageList;
export const selectGoals = (state) => state.root.goals;
export const fetchStageById = (stageId) => (state) =>
  state.root.stageList.find((d) => d.id === stageId);
export const fetchStagesByIds = (stageIds) => (state) =>
  state.root.stageList.filter((d) => stageIds.indexOf(d.id) > -1);

export default coreSlice.reducer;
